// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-3D2mwH0","wrapper":"wrapper-QPLqykX"};